export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00267.79d28ff6.png";